import type { DoshaResult } from "@/lib/api";

export type MangalDosha = DoshaResult;

export function findMangalDosha(doshas: DoshaResult[]): DoshaResult | null {
  return (
    doshas.find(
      (d) =>
        d.dosha_id === "mangal_dosh" ||
        d.name_en.toLowerCase().includes("mangal") ||
        d.name_en.toLowerCase().includes("manglik") ||
        d.name_en.toLowerCase().includes("kuja")
    ) ?? null
  );
}

export function isManglikResult(dosha: DoshaResult | null): boolean {
  return dosha?.is_present === true;
}

export function severityLabel(severity: number): string {
  if (severity >= 0.7) return "High";
  if (severity >= 0.4) return "Medium / Anshik";
  if (severity > 0) return "Low / Mild";
  return "None";
}

export function resultSummary(dosha: DoshaResult): string {
  if (!dosha.is_present) {
    return "Mars is not in a Mangal Dosha trigger position from the checked reference points.";
  }
  if (dosha.cancellation_applied) {
    return "Mangal Dosha is present, but cancellation factors reduce its practical impact.";
  }
  if (dosha.severity < 0.7) {
    return "This is an anshik or partial Mangal Dosha pattern, not a severe marriage veto.";
  }
  return "This is a stronger Mangal Dosha pattern. Read the Mars placement and remedies before making marriage decisions.";
}
